import * as ACTION_TYPES from "./actionTypes";
// import _ from "lodash";
import { secure } from "./API/faiz";
import { FAIZ_ACCESS_TOKEN } from "../constants/staticKeys";
import moment from "moment";
import { errorMessageHandle } from "../constants/utilities";
import { toast } from "react-toastify";

const {
  UPDATE_RESERVATION_PROPS,
  DELETE_RESERVATION_PROPS,
  MERGE_RESERVATION_PROPS,
} = ACTION_TYPES;
export const updateReservationProp = (prop, value) => {
  return { type: UPDATE_RESERVATION_PROPS, payload: [{ prop, value }] };
};
export const updateReservationProps = (payload) => {
  return { type: UPDATE_RESERVATION_PROPS, payload: payload };
};
export const mergeReservationProps = (payload) => {
  return { type: MERGE_RESERVATION_PROPS, payload: payload };
};
export const deleteReservationProp = (prop) => {
  return { type: DELETE_RESERVATION_PROPS, payload: [{ prop }] };
};
export const deleteReservationProps = (payload) => {
  return { type: DELETE_RESERVATION_PROPS, payload };
};

export const getReservations = (prop, page, param) => async (dispatch) => {
  let url = "/reservation?page=" + page;
  let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);
  dispatch({
    type: UPDATE_RESERVATION_PROPS,
    payload: [{ prop: "isResLoading", value: true }],
  });
  secure(token)
    .get(url, { params: param })
    .then((response) => {
      dispatch({
        type: UPDATE_RESERVATION_PROPS,
        payload: [{ prop, value: response.data.reservations }],
      });
      // toast.success(response.data.msg);
    })
    .catch((error) => {
      dispatch({
        type: UPDATE_RESERVATION_PROPS,
        payload: [{ prop, value: [] }],
      });
      let message;
      message = errorMessageHandle(error);
      toast.error(message);
    })
    .finally((f) => {
      dispatch({
        type: UPDATE_RESERVATION_PROPS,
        payload: [{ prop: "isResLoading", value: false }],
      });
    });
};

export const deleteReservation = (reservation, index) => async (dispatch) => {
  if (reservation.hasOwnProperty("id")) {
    let url = "/reservation";
    let param = { reservation: [reservation.id] };
    let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);
    dispatch({
      type: UPDATE_RESERVATION_PROPS,
      payload: [
        { prop: "reservations.data." + index + ".isDeleting", value: true },
      ],
    });
    secure(token)
      .delete(url, { data: param })
      .then((response) => {
        dispatch({
          type: DELETE_RESERVATION_PROPS,
          payload: [{ prop: "reservations.data." + index }],
        });
      })
      .catch((error) => {
        dispatch({
          type: UPDATE_RESERVATION_PROPS,
          payload: [
            {
              prop: "reservations.data." + index + ".isDeleting",
              value: false,
            },
          ],
        });
        let message;
        message = errorMessageHandle(error);
        toast.error(message);
      });
  } else {
    dispatch({
      type: DELETE_RESERVATION_PROPS,
      payload: [{ prop: "reservations.data." + index }],
    });
  }
};

export const openReservationSchedule =
  (reservation, history, reservationIndex) => async (dispatch, getState) => {
    let url = "/reservationschedule";
    let param = {
      filters: [
        { filter_column: "reservation_id", filter_value: reservation.id },
      ],
      page_size: 9999,
    };
    let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);
    dispatch({
      type: UPDATE_RESERVATION_PROPS,
      payload: [
        {
          prop: "reservations." + reservationIndex + ".isScheduleLoading",
          value: true,
        },
      ],
    });
    secure(token)
      .get(url, { params: param })
      .then((response) => {
        dispatch({
          type: UPDATE_RESERVATION_PROPS,
          payload: [
            {
              prop: "reservationSchedule",
              value: response.data.reservation_schedules.data,
            },
          ],
        });
        let start = moment(reservation.arrival, "YYYY-MM-DD HH:mm:ss").startOf(
          "week"
        );
        let end = moment(reservation.departure, "YYYY-MM-DD HH:mm:ss").endOf(
          "week"
        );

        let date = start.clone();
        let dateList = [];
        let week = [];
        while (date.diff(end) < 0) {
          let d = date.format("YYYY-MM-DD HH:mm:ss");

          let inTrip = date.isBetween(
            moment(reservation.arrival, "YYYY-MM-DD HH:mm:ss"),
            moment(reservation.departure, "YYYY-MM-DD HH:mm:ss"),
            "day",
            "[]"
          );
          let obj = { date: d, isWithinTrip: inTrip };
          week.push(obj);
          if (week.length === 7) {
            dateList.push(week);
            week = [];
          }
          date = date.add(1, "days");
        }
        dispatch({
          type: UPDATE_RESERVATION_PROPS,
          payload: [
            {
              prop: "calendar.start",
              value: start.format("YYYY-MM-DD HH:mm:ss"),
            },
            { prop: "calendar.end", value: end.format("YYYY-MM-DD HH:mm:ss") },
            { prop: "calendar.dates", value: dateList },
            { prop: "reservation", value: reservation },
          ],
        });
        history.push("./reservationSchedule");
      })
      .catch((error) => {
        let message;
        message = errorMessageHandle(error);
        toast.error(message);
      })
      .finally((f) => {});
  };

export const openBulkReservationSchedule =
  (fromDate, toDate, history) => async (dispatch, getState) => {
    let start = moment(fromDate, "YYYY-MM-DD HH:mm:ss").startOf("week");
    let end = moment(toDate, "YYYY-MM-DD HH:mm:ss").endOf("week");
    let date = start.clone();
    let dateList = [];
    let week = [];
    let reservationSchedule = [];

    while (date.diff(end) < 0) {
      let d = date.format("YYYY-MM-DD HH:mm:ss");

      let inTrip = date.isBetween(
        moment(fromDate, "YYYY-MM-DD HH:mm:ss"),
        moment(toDate, "YYYY-MM-DD HH:mm:ss"),
        "day",
        "[]"
      );
      if (inTrip === true) {
        reservationSchedule.push({
          date: date.format("YYYY-MM-DD HH:mm:ss"),
          schedule: {
            isOpenDropDown: false,
            visits: [],
            score: 0,
            date: date.format("YYYY-MM-DD HH:mm:ss"),
          },
        });
      }
      let obj = { date: d, isWithinTrip: inTrip };
      week.push(obj);
      if (week.length === 7) {
        dateList.push(week);
        week = [];
      }
      date = date.add(1, "days");
    }

    dispatch({
      type: UPDATE_RESERVATION_PROPS,
      payload: [
        { prop: "calendar.start", value: start.format("YYYY-MM-DD HH:mm:ss") },
        { prop: "calendar.end", value: end.format("YYYY-MM-DD HH:mm:ss") },
        { prop: "calendar.dates", value: dateList },
        { prop: "reservationSchedule", value: reservationSchedule },
        { prop: "isBulkOpen", value: false },
      ],
    });
    history.push("./bulkReservationSchedule");
  };

export const addVisitToReservationSchedule =
  (index, visit) => async (dispatch, getState) => {
    await dispatch({
      type: MERGE_RESERVATION_PROPS,
      payload: [
        {
          prop: "reservationSchedule." + index + ".schedule.visits",
          value: visit,
        },
      ],
    });
    let newVisits =
      getState().reservationReducer.reservationSchedule[index].schedule.visits;
    let totalScore = calculateScore(newVisits);
    dispatch({
      type: UPDATE_RESERVATION_PROPS,
      payload: [
        {
          prop: "reservationSchedule." + index + ".schedule.score",
          value: totalScore,
        },
      ],
    });
  };

export const removeVisitToReservationSchedule =
  (index, visitIndex) => async (dispatch, getState) => {
    await dispatch({
      type: DELETE_RESERVATION_PROPS,
      payload: [
        {
          prop:
            "reservationSchedule." + index + ".schedule.visits." + visitIndex,
        },
      ],
    });
    let newVisits =
      getState().reservationReducer.reservationSchedule[index].schedule.visits;
    let totalScore = calculateScore(newVisits);
    dispatch({
      type: UPDATE_RESERVATION_PROPS,
      payload: [
        {
          prop: "reservationSchedule." + index + ".schedule.score",
          value: totalScore,
        },
      ],
    });
  };

const calculateScore = (visits) => {
  let totalScore = 0;
  for (let i = 0; i < visits.length; i++) {
    totalScore = totalScore + parseFloat(visits[i].score);
  }
  return totalScore;
};

export const createNewReservationSchedule =
  (date, schedule, reservation_id, calWeekIndex, calDayIndex) =>
  async (dispatch) => {
    let url = "/reservationschedule";
    let param = { schedules: [{ date, schedule, reservation_id }] };
    let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);
    dispatch({
      type: UPDATE_RESERVATION_PROPS,
      payload: [
        {
          prop:
            "calendar.dates." + calWeekIndex + "." + calDayIndex + ".isLoading",
          value: true,
        },
      ],
    });
    secure(token)
      .post(url, param)
      .then((response) => {
        dispatch({
          type: MERGE_RESERVATION_PROPS,
          payload: [
            {
              prop: "reservationSchedule",
              value: response.data.reservation_schedules,
            },
          ],
        });
      })
      .catch((error) => {
        let message;
        message = errorMessageHandle(error);
        toast.error(message);
      })
      .finally((f) => {
        dispatch({
          type: UPDATE_RESERVATION_PROPS,
          payload: [
            {
              prop:
                "calendar.dates." +
                calWeekIndex +
                "." +
                calDayIndex +
                ".isLoading",
              value: false,
            },
          ],
        });
      });
  };

export const saveReservationSchedule =
  (reservationSchedule) => async (dispatch, getState) => {
    let url = "/reservationschedule";
    let param = { schedules: reservationSchedule };
    let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);
    dispatch({
      type: UPDATE_RESERVATION_PROPS,
      payload: [
        { prop: "savingReservationSchedule", value: true },
        { prop: "savedResSchCount", value: 0 },
      ],
    });
    secure(token)
      .post(url, param)
      .then((response) => {
        dispatch({
          type: UPDATE_RESERVATION_PROPS,
          payload: [
            {
              prop: "reservationSchedule",
              value: response.data.reservation_schedules,
            },
            {
              prop: "reservation.efficiency",
              value: response.data.efficiency.percentage,
            },
          ],
        });
      })
      .catch((error) => {
        let message;
        message = errorMessageHandle(error);
        toast.error(message);
      })
      .finally((f) => {
        dispatch({
          type: UPDATE_RESERVATION_PROPS,
          payload: [{ prop: "savingReservationSchedule", value: false }],
        });
      });
    // for (let i = 0; i < reservationSchedule.length; i++) {
    //   dispatch({
    //     type: UPDATE_RESERVATION_PROPS,
    //     payload: [{ prop: "reservationSchedule." + i + ".isSaving", value: true }]
    //   });
    //   let schedule = reservationSchedule[i];
    //   param = { schedules: [schedule] };
    //   secure(token)
    //     .post(url, param)
    //     .then(response => {
    //       let savedResSchCount = getState().reservationReducer.savedResSchCount;
    //
    //       dispatch({
    //         type: UPDATE_RESERVATION_PROPS,
    //         payload: [{ prop: "reservationSchedule." + i, value: response.data.reservation_schedules[0] }]
    //       });
    //     })
    //     .catch(error => {
    //       let message;
    //       message = errorMessageHandle(error);
    //       toast.error(message);
    //     })
    //     .finally(f => {
    //       let savedResSchCount = getState().reservationReducer.savedResSchCount;
    //       dispatch({
    //         type: UPDATE_RESERVATION_PROPS,
    //         payload: [{ prop: "savedResSchCount", value: savedResSchCount + 1 }]
    //       });
    //       savedResSchCount = savedResSchCount + 1;
    //       if (savedResSchCount == reservationSchedule.length) {
    //         dispatch({
    //           type: UPDATE_RESERVATION_PROPS,
    //           payload: [{ prop: "savingReservationSchedule", value: false }]
    //         });
    //       }
    //       dispatch({
    //         type: UPDATE_RESERVATION_PROPS,
    //         payload: [{ prop: "reservationSchedule." + i + ".isSaving", value: false }]
    //       });
    //     });
    // }
  };

export const submitRooms = (reservationRooms) => async (dispatch, getState) => {
  let url = "/reservationroom";
  let param = { reservation_rooms: reservationRooms.data };
  let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);

  dispatch({
    type: UPDATE_RESERVATION_PROPS,
    payload: [{ prop: "isRoomSaving", value: true }],
  });
  secure(token)
    .post(url, param)
    .then((response) => {
      dispatch({
        type: UPDATE_RESERVATION_PROPS,
        payload: [
          { prop: "isRoomModalOpen", value: false },
          { prop: "roomModalReservationId", value: null },
          { prop: "reservationRooms", value: [] },
        ],
      });
    })
    .catch((error) => {
      let message;
      message = errorMessageHandle(error);
      toast.error(message);
    })
    .finally((f) => {
      dispatch({
        type: UPDATE_RESERVATION_PROPS,
        payload: [{ prop: "isRoomSaving", value: false }],
      });
    });
};

export const deleteRoom = (index, resroom) => async (dispatch, getState) => {
  let url = "/reservationroom";
  let param = { reservation_rooms: [resroom.id] };
  let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);
  dispatch({
    type: UPDATE_RESERVATION_PROPS,
    payload: [
      { prop: "reservationRooms.data." + index + ".isRoomDeleting", value: true },
    ],
  });
  secure(token)
    .delete(url, { data: param })
    .then((response) => {
      dispatch({
        type: DELETE_RESERVATION_PROPS,
        payload: [{ prop: "reservationRooms.data." + index }],
      });
    })
    .catch((error) => {
      let message;
      message = errorMessageHandle(error);
      toast.error(message);
    })
    .finally((f) => {
      dispatch({
        type: UPDATE_RESERVATION_PROPS,
        payload: [
          {
            prop: "reservationRooms.data." + index + ".isRoomDeleting",
            value: false,
          },
        ],
      });
    });
};

export const getResevationRooms =
  (reservation_number, index) => async (dispatch, getState) => {
    let url = "/reservationroom";
    let param = {
      filters: [
        { filter_column: "reservation_id", filter_value: reservation_number },
      ],
      page_size: 9999,
    };
    let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);
    dispatch({
      type: UPDATE_RESERVATION_PROPS,
      payload: [
        { prop: "reservations.data." + index + ".isRoomLoading", value: true },
      ],
    });
    secure(token)
      .get(url, { params: param })
      .then((response) => {
        dispatch({
          type: UPDATE_RESERVATION_PROPS,
          payload: [
            {
              prop: "reservationRooms",
              value: response.data.reservation_rooms,
            },
            { prop: "isRoomModalOpen", value: true },
            { prop: "roomModalReservationId", value: reservation_number },
          ],
        });
      })
      .catch((error) => {
        let message;
        message = errorMessageHandle(error);
        toast.error(message);
      })
      .finally((f) => {
        dispatch({
          type: UPDATE_RESERVATION_PROPS,
          payload: [
            {
              prop: "reservations.data." + index + ".isRoomLoading",
              value: false,
            },
          ],
        });
      });
  };

export const applyBulkChange =
  (fromDate, toDate, reservationSchedule, history) =>
  async (dispatch, getState) => {
    let url = "/reservationschedule/bulk";
    let param = { schedules: reservationSchedule, from: fromDate, to: toDate };
    let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);
    dispatch({
      type: UPDATE_RESERVATION_PROPS,
      payload: [{ prop: "isBulkApplying", value: true }],
    });
    secure(token)
      .post(url, param)
      .then((response) => {
        toast.success(response.data.msg);
        history.push("./reservations");
      })
      .catch((error) => {
        let message;
        message = errorMessageHandle(error);
        toast.error(message);
      })
      .finally((f) => {
        dispatch({
          type: UPDATE_RESERVATION_PROPS,
          payload: [{ prop: "isBulkApplying", value: false }],
        });
      });
  };
